var _defs, _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexCableInternet01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M311.15,286.29V140.76H80.84V286.29h87.38v24.64H128.54v9.67H263.45v-9.67H223.77V286.29Zm-97,24.64H177.89V286.29H214.1Zm-45.88-34.31H90.51V150.43h211V276.62H168.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 96.51,
    y: 156.37,
    width: 198.97,
    height: 114.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M333.94,124.34a14.78,14.78,0,0,0-10.48,4.34l10.48,10.48,10.49-10.48A14.81,14.81,0,0,0,333.94,124.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M371.76,101.34l6.53-6.53a62.65,62.65,0,0,0-88.7,0l6.53,6.53a53.43,53.43,0,0,1,75.64,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M349.21,123.89l6.53-6.53a30.81,30.81,0,0,0-43.6,0l6.53,6.53a21.58,21.58,0,0,1,30.54,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.1,113l6.53-6.54a46.17,46.17,0,0,0-65.37,0l6.53,6.54a36.93,36.93,0,0,1,52.31,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexCableInternet01);
export default __webpack_public_path__ + "static/media/Vortex_Cable&Internet-01.b06222cec472d133308078d8bbbad9d0.svg";
export { ForwardRef as ReactComponent };